export function isChromatic() {
	return window.location.href.indexOf('chromatic=true') > -1;
}
